/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericModelNode } from "../Schema/IModelNode";

export function isModelValueRequired(model: TGenericModelNode): boolean {
	return !!(model?.schema?.opts as Record<string, { required?: boolean }>)?.constraints?.required;
}
